// extracted by mini-css-extract-plugin
export default {"self-assesment":"style_self-assesment__McEE5","section":"style_section__NXi-4","link":"style_link__IUuUw"};